import React from "react";
import { Container, Button } from "react-bootstrap";
import { useScroll } from "../../../context/scroll-context";

const PortfolioHeroBanner = () => {
  const { scrollToSection, contactform } = useScroll();

  const handleScrollAndClose = (refName) => {
    scrollToSection(refName);
  };
  return (
    <section className="portfolio hero-section d-flex align-items-center justify-content-center">
      <Container fluid>
        <div className="content-block mb-3">
          <h2 className="text-white mb-3 ft-wt-700 mb-lg-5 big-title">
            Portfolio
          </h2>
          <div>
            <Button className="text-uppercase" variant="secondary">
              <h5
                className="mb-0 text-primary"
                onClick={() => handleScrollAndClose(contactform)}
              >
                Apply for free 2 weeks trial
              </h5>
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default PortfolioHeroBanner;
